import { render, staticRenderFns } from "./approve-panel.vue?vue&type=template&id=46a5eaf0&scoped=true"
import script from "./approve-panel.vue?vue&type=script&lang=js"
export * from "./approve-panel.vue?vue&type=script&lang=js"
import style0 from "./approve-panel.vue?vue&type=style&index=0&id=46a5eaf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a5eaf0",
  null
  
)

export default component.exports